import type { AllPrivacySettings, UpdatePrivacySettingsResponse } from '@mrb91002/shared-types'

export type { AllPrivacySettings }

import { secureFetch, SECURE_API_BASE } from './helpers'

/**
 * Get all privacy settings
 */
export async function getPrivacySettings(idToken: string): Promise<AllPrivacySettings> {
  return secureFetch<AllPrivacySettings>(`${SECURE_API_BASE}/privacy-settings`, idToken, {
    method: 'GET',
  })
}

/**
 * Update all privacy settings
 */
export async function updatePrivacySettings(
  settings: Partial<AllPrivacySettings>,
  idToken: string,
): Promise<UpdatePrivacySettingsResponse> {
  return secureFetch<UpdatePrivacySettingsResponse>(`${SECURE_API_BASE}/privacy-settings`, idToken, {
    method: 'PUT',
    body: JSON.stringify(settings),
  })
}
